import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { API_URLS } from '../../../shared/constants/api-urls.constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DentalCredentialsService {
  private headers = new HttpHeaders({
    'Authorization': `Bearer ` + localStorage.getItem("accessToken"),
    'Content-Type': 'application/json'
  });
  
  constructor(private http: HttpClient) { }

  saveDocument(file: any, requestPayload: any): Promise<any> {
    const formData = new FormData();
    formData.append('file', file); // Append the file
    Object.keys(requestPayload).forEach((key) => {
      if (typeof requestPayload[key] === 'object' && requestPayload[key] !== null) {
        // Serialize objects to JSON strings
        formData.append(key, JSON.stringify(requestPayload[key]));
      } else {
        formData.append(key, requestPayload[key]);
      }
    });

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${localStorage.getItem("accessToken")}`,
      // Do not include 'Content-Type' here
    });

    const url = `${environment.credentialGetApiUrl}${API_URLS.SAVE_DOCUMENT}`;
    return this.http.post(url, formData, { headers }).toPromise();
  }

  saveCredentialing(payload: any) {
    const url = `${environment.credentialGetApiUrl}${API_URLS.SAVE_CREDENTIAL}`;
    return this.http.post(url, payload);
  }

  viewAzureDocument(fileName: string) {
    const url = `${environment.credentialGetApiUrl}${API_URLS.GET_AZURE_DOCUMENT}/${fileName}`
    return this.http.get(url, { responseType: 'blob', observe: 'response' });
  }

  deleteDocument(requestParams: any) {
    const url = `${environment.credentialGetApiUrl}${API_URLS.DELETE_DOCUMENTS}`
    return this.http.put(url, requestParams, { headers: this.headers });
  }

  doownloadPreLoginPdf(payload: any): Observable<any> {
    const url = `${environment.memberBenefitsUrl}${API_URLS.BENEFIT_PDF_URL}`;
    return this.http.post(url, payload, { headers: this.headers, responseType: 'arraybuffer' });
  }
  getLocationDocuments(locationId: any) {
      return this.http.get(`${environment.credentialGetApiUrl}/credentialing-transac/location/documents/${locationId}`);
    }
}
